module.exports = __webpack_public_path__ + "ae7a904d16c6f45b9952fd3ba83f03aa.pdf";